export interface LoginDto {
    id: string,
    password: string
}

export const initialLoginDto: LoginDto = {
    id: "",
    password: ""
}